import React from "react";
import { Anchor, CallToAction } from "discover.medical.react-component-library";
import { Avatar } from "./_.styled";
import {
  appendReturnToUrl,
  appendAmplitudeDeviceId,
} from "../../util/userActions";

const getAction2 = (cta) => {
  const { subscribe, subscribeUrl, register, registerUrl } = cta;
  if (subscribe) {
    return {
      href: appendReturnToUrl(subscribeUrl),
      children: subscribe,
    };
  }
  if (register) {
    return {
      href: appendAmplitudeDeviceId(appendReturnToUrl(registerUrl)),
      children: register,
    };
  }
};

const NotPersonalized = ({ cta, affiliationName }) => {
  return (
    <CallToAction
      data-testid="home-cta-card"
      avatar={<Avatar foregroundColor="gray600" />}
      heading={!cta.subContent && affiliationName}
      message={<span dangerouslySetInnerHTML={{ __html: cta.content }} />}
      alert={cta.alert}
      action1Props={{
        href: appendAmplitudeDeviceId(appendReturnToUrl(cta.signInUrl)),
        children: cta.signIn,
      }}
      action2Props={getAction2(cta)}
      submessage={cta.subContent && !cta.freeTrial && <>{cta.subContent}</>}
    >
      {cta.freeTrial && (
        <>
          {cta.subContent}
          <Anchor href={cta.freeTrialUrl} fontSize="inherit">
            <span dangerouslySetInnerHTML={{ __html: cta.freeTrial }} />
          </Anchor>
        </>
      )}
    </CallToAction>
  );
};

export default NotPersonalized;
